<template>
  <div>
    <!-- Page Title Header Starts-->
    <div class="w-100 card-statistics1" style="min-height: 20vh">
      <!-- Customer card -->
      <div class="card-col1 col-xl-4 col-lg-4 col-md-4 col-6">
        <div class="card-body">
          <div
            class="d-flex align-items-center justify-content-center flex-column flex-sm-row"
          >
            <div class="text-primary mr-0 mr-sm-4 icon-lg">
              <router-link
                :to="{
                  path: '/customers',
                }"
                style="text-decoration: none; color: #000000"
              >
                <countTo
                  :startVal="countCustomer.startVal"
                  :endVal="countCustomer.endVal"
                  :duration="countCustomer.duration"
                ></countTo>
              </router-link>
            </div>
            <div class="wrapper text-center text-sm-left">
              <p class="card-text mb-0 fw-light text-dark">Customers</p>
              <div class="fluid-container"></div>
            </div>
            <img :src="customerIcon" alt="customer" class="col-img" />
          </div>
        </div>
      </div>

      <!-- Drivercard -->
      <div class="card-col1 col-xl-4 col-lg-4 col-md-4 col-6">
        <div class="card-body">
          <div
            class="d-flex align-items-center justify-content-center flex-column flex-sm-row"
          >
            <div class="text-primary mr-0 mr-sm-4 icon-lg">
              <router-link
                :to="{
                  path: '/drivers',
                }"
                style="text-decoration: none; color: #000000"
              >
                <countTo
                  :startVal="countDriver.startVal"
                  :endVal="countDriver.endVal"
                  :duration="countDriver.duration"
                ></countTo>
              </router-link>
            </div>
            <div class="wrapper text-center text-sm-left">
              <p class="card-text mb-0 fw-light text-dark">Drivers</p>
              <div class="fluid-container"></div>
            </div>
            <img :src="driverIcon" alt="driver" class="col-img" />
          </div>
        </div>
      </div>

      <!-- Help & Support card -->
      <div class="card-col1 col-xl-4 col-lg-4 col-md-4 col-6">
        <div class="card-body">
          <div
            class="d-flex align-items-center justify-content-center flex-column flex-sm-row"
          >
            <div class="text-primary mr-0 mr-sm-4 icon-lg">
              <router-link
                :to="{
                  path: '/help-and-support',
                }"
                style="text-decoration: none; color: #000000"
              >
                <countTo
                  :startVal="countHelp.startVal"
                  :endVal="countHelp.endVal"
                  :duration="countHelp.duration"
                ></countTo>
              </router-link>
            </div>
            <div class="wrapper text-center text-sm-left">
              <p class="card-text mb-0 fw-light text-dark">Help & Support</p>
              <div class="fluid-container"></div>
            </div>
            <img :src="helpIcon" alt="help" class="col-img" />
          </div>
        </div>
      </div>
    </div>

    <!-- Total trips -->
    <div class="w-100 card-statistics2">
      <div class="trips-col card-col2 col-xl-4 col-lg-4 col-md-4 col-6">
        <div class="card-body">
          <div
            class="d-flex align-items-center justify-content-center flex-column flex-sm-row"
          >
            <div class="text-primary mr-0 mr-sm-4 icon-lg">
              <router-link
                :to="{
                  path: '/trips/assign/list',
                }"
                style="text-decoration: none; color: #000000"
              >
                <countTo
                  :startVal="countTotalTrip.startVal"
                  :endVal="countTotalTrip.endVal"
                  :duration="countTotalTrip.duration"
                ></countTo>
              </router-link>
            </div>
            <div class="wrapper text-center text-sm-left">
              <p class="card-text mb-0 fw-light text-dark">Total Trips</p>
              <div class="fluid-container"></div>
            </div>
            <img :src="driverIcon" alt="driver" class="col-img" />
          </div>
        </div>
      </div>

      <!-- Total Vechicle -->
      <div class="vechicle-col col card-col2 col-xl-4 col-lg-4 col-md-4 col-6">
        <div class="card-body">
          <div
            class="d-flex align-items-center justify-content-center flex-column flex-sm-row"
          >
            <div class="text-primary mr-0 mr-sm-4 icon-lg">
              <router-link
                :to="{
                  path: '/buses',
                }"
                style="text-decoration: none; color: #000000"
              >
                <countTo
                  :startVal="countVechicles.startVal"
                  :endVal="countVechicles.endVal"
                  :duration="countVechicles.duration"
                ></countTo>
              </router-link>
            </div>
            <div class="wrapper text-center text-sm-left">
              <p class="card-text mb-0 fw-light text-dark">Total Vechicles</p>
              <div class="fluid-container"></div>
            </div>
            <img :src="helpIcon" alt="help" class="col-img" />
          </div>
        </div>
      </div>

      <!-- Booking Status card -->
      <div class="booking-col card-col2 col-xl-4 col-lg-4 col-md-4 col-6">
        <div class="booking-col-body">
          <div class="heading">
            Booking Status
            <img :src="customerIcon" alt="" class="col-img2" />
          </div>
          <div
            class="d-flex align-items-center justify-content-center flex-column"
          >
            <div class="text-primary mr-0 icon-lg">
              <!-- <i class="mdi mdi-ticket-confirmation"></i> -->
              <router-link
                :to="{
                  path: '/bookings/scheduled',
                }"
                style="text-decoration: none; color: #000000"
              >
                <countTo
                  :startVal="countTotalBooking.startVal"
                  :endVal="countTotalBooking.endVal"
                  :duration="countTotalBooking.duration"
                ></countTo>
              </router-link>
            </div>
            <div class="wrapper text-center text-sm-right">
              <p class="card-text mb-0 fw-light text-dark">Ticket Booking</p>
            </div>
          </div>

          <div
            class="d-flex align-items-center justify-content-center flex-column"
          >
            <div class="text-primary mr-0 icon-lg">
              <!-- <i class="mdi mdi-ticket-confirmation"></i> -->
              <router-link
                :to="{
                  path: '/bookings/scheduled',
                }"
                style="text-decoration: none; color: #000000"
              >
                <countTo
                  :startVal="countScheduledBooking.startVal"
                  :endVal="countScheduledBooking.endVal"
                  :duration="countScheduledBooking.duration"
                ></countTo>
              </router-link>
            </div>
            <div class="wrapper text-center text-sm-left">
              <p class="card-text mb-0 fw-light text-dark">Scheduled Booking</p>
            </div>
          </div>

          <div
            class="d-flex align-items-center justify-content-center flex-column"
          >
            <div class="text-primary mr-0 icon-lg">
              <!-- <i class="mdi mdi-ticket-confirmation"></i> -->
              <router-link
                :to="{
                  path: '/bookings/completed',
                }"
                style="text-decoration: none; color: #000000"
              >
                <countTo
                  :startVal="countCompletedBooking.startVal"
                  :endVal="countCompletedBooking.endVal"
                  :duration="countCompletedBooking.duration"
                ></countTo>
              </router-link>
            </div>
            <div class="wrapper text-center text-sm-left">
              <p class="card-text mb-0 fw-light text-dark">Completed Booking</p>
            </div>
          </div>
        </div>
      </div>
      <div class="walletLine-graph col-xl-6 col-lg-6 col-md-6 col-6">
        <div class="graph-body">
          <walletLine />
        </div>
      </div>

      <!-- <div class="card-col">
              <div class="card-body">
                <bookingBar />
              </div>
            </div> -->
    </div>
  </div>
</template>

<script>
import { dashboardService } from "../../services/dashboard.service";
import driverIcon from "../../assets/images/dashboard/driver.png";
import customerIcon from "../../assets/images/dashboard/customer.png";
import helpIcon from "../../assets/images/dashboard/helpNsupport.png";
import countTo from "vue-count-to";
import walletLine from "../charts/walletLine";
// import bookingBar from "../charts/bookingBar";
export default {
  name: "CountTo",
  data() {
    return {
      countDriver: {
        startVal: 0,
        endVal: 0,
      },
      countCustomer: {
        startVal: 0,
        endVal: 0,
      },
      countHelp: {
        startVal: 0,
        endVal: 0,
      },
      countTotalBooking:{
        startVal: 0,
        endVal: 0,
      },
      countCompletedBooking:{
        startVal: 0,
        endVal: 0,
      },
      countScheduledBooking: {
        startVal: 0,
        endVal: 0,
      },
      countTotalTrip: {
        startVal: 0,
        endVal: 0,
      },
      countVechicles: {
        startVal: 0,
        endVal: 0,
      },
      driverIcon,
      customerIcon,
      helpIcon,
    };
  },
  components: { countTo, walletLine },
  mounted() {
    this.loadcount();
  },
  methods: {
    loadcount() {
      dashboardService.loadCountData().then((response) => {
        this.countDriver = response.data.countDriver;
        this.countCustomer = response.data.countCustomer;
        this.countHelp = response.data.countHelp;
        this.countTotalBooking = response.data.totalBookings;
        this.countScheduledBooking = response.data.totalScheduledBooking;
        this.countCompletedBooking = response.data.totalCompletedBooking;
        this.countVechicles = response.data.totalVechicles;
        this.countTotalTrip = response.data.totalTrip;

        // this.countTotalBooking = response.data.countTotalBooking;
        // this.countTodayCompletedBooking = response.data.todayCompletedBooking;
        // this.countScheduledBooking = response.data.todayScheduledBooking;
      });
    },
    // toggleProBanner: function () {
    //   $('body').toggleClass('pro-banner-collapse')
    // }
  },
};
</script>

<style></style>
